<div class="decoration"></div>
<div class="content">
  <div class="cols">
    <div class="main">
      <div class="spacer"></div>
      <div class="center">
        <router-outlet></router-outlet>
      </div>
      <div class="spacer"></div>
    </div>
  </div>
</div>
